import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-payg-payment-failed',
  templateUrl: './payg-payment-failed.component.html',
  styleUrl: './payg-payment-failed.component.css',
  standalone: false
})
export class PaygPaymentFailedComponent {

  constructor(private router: Router) { }

  tryAgain() {
    this.router.navigate(['/admin-payg']);
  }
}
